// extracted by mini-css-extract-plugin
export default {"promo":"HomePage_promo__CNyTq","promoDescr":"HomePage_promoDescr__rpzal"};